__turbopack_context__.v({
  "buttonContainer": "DonationList-module__g82WzG__buttonContainer",
  "heading": "DonationList-module__g82WzG__heading",
  "headingIcon": "DonationList-module__g82WzG__headingIcon",
  "innerContainer": "DonationList-module__g82WzG__innerContainer",
  "pageButton": "DonationList-module__g82WzG__pageButton",
});
